<template>
  <div class="c-special-keys">
    <div class="title">
      Special
    </div>
    <div
      class="key"
      :class="{ selected: anyKeys.includes(selectedKey) }"
      @click="onAnyClick"
    >
      <div class="text">
        Any
      </div>
    </div>
    <div class="desc">
      {{ $t("keyboard.any.desc") }}
    </div>
    <a-modal
      v-model="anyVisible"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="any-key-modal"
    >
      <div class="any-key">
        <div class="title">
          {{ $t("keyboard.any.title") }}
        </div>
        <div class="fields">
          <md-field class="field">
            <label for="press">{{ $t("keyboard.any.press") }}</label>
            <md-select v-model="anyKey.first_key" name="press" id="press">
              <template v-for="(allKey, key) in allKeys">
                <md-option v-if="key" :value="key" :key="'press' + key">
                  {{ allKey.nowrapText }}
                  {{
                    allKey.desc ? ` [${allKey.desc[isCN ? "cn" : "en"]}]` : ""
                  }}
                </md-option>
              </template>
            </md-select>
          </md-field>
          <md-field class="field">
            <label for="hold">{{ $t("keyboard.any.hold") }}</label>
            <md-select v-model="anyKey.second_key" name="hold" id="hold">
              <template v-for="(allKey, key) in allKeys">
                <md-option v-if="key" :value="key" :key="'hold' + key">
                  {{ allKey.nowrapText }}
                  {{
                    allKey.desc ? ` [${allKey.desc[isCN ? "cn" : "en"]}]` : ""
                  }}
                </md-option>
              </template>
            </md-select>
          </md-field>
          <md-field class="field">
            <label>{{ $t("keyboard.any.interval") }}</label>
            <md-input
              v-model="anyKey.interval_time"
              @blur="onIntervalInput"
              type="number"
              min="200"
              max="10000"
            ></md-input>
            <span class="md-suffix">ms</span>
          </md-field>
        </div>
        <div class="buttons">
          <md-button class="button" @click="anyVisible = false">
            {{ $t("cancel") }}
          </md-button>
          <md-button
            class="button"
            :disabled="
              !anyKey.first_key || !anyKey.second_key || !anyKey.interval_time
            "
            @click="onAnyOk"
          >
            {{ $t("yes") }}
          </md-button>
        </div>
      </div>
    </a-modal>
    <div
      class="key"
      :class="{ selected: macroKeys.includes(selectedKey) }"
      @click="onMacroClick"
      v-if="false"
    >
      <div class="text">
        Macro
      </div>
    </div>
    <div class="desc" v-if="false">
      {{ $t("keyboard.macro.desc") }}
    </div>
    <a-modal
      v-model="macroVisible"
      width="800px"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="macro-key-modal"
    >
      <div class="macro-key">
        <div class="title">
          {{ $t("keyboard.macro.title") }}
        </div>
        <div class="fields">
          <c-macros />
        </div>
        <div class="buttons">
          <md-button class="button" @click="macroVisible = false">
            {{ $t("cancel") }}
          </md-button>
          <md-button
            class="button"
            :disabled="!macroKey.interval_time"
            @click="onAnyOk"
          >
            {{ $t("yes") }}
          </md-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { anyKeys, macroKeys } from "./SpecialKeys";

export default {
  name: "CVirtualSpecialKeys",
  props: {
    dispatchType: String,
    profile: {
      type: Object,
      default: () => {},
    },
    selectedKey: String,
    selectedKeyIndex: Number,
    layerIndex: Number,
    allKeys: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      anyKeys,
      anyKey: {
        ph_key_data: "",
        first_key: null,
        second_key: null,
        interval_time: 200,
      },
      anyVisible: false,
      macroKeys,
      macroKey: {
        macro_value: "",
        first_key: null,
        second_key: null,
        interval_time: 200,
      },
      macroVisible: false,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
  },
  methods: {
    onKeyClick(key) {
      const selectedKey = this.selectedKey;
      if (selectedKey === key) return;
      this.$emit("key-click", key);
      if (this.anyKeys.includes(selectedKey)) {
        let data = this.profile.data;
        const index = data.tab_key.findIndex(
          (k) => k.ph_key_data === selectedKey
        );
        if (index > -1) {
          data.tab_key.splice(index, 1);
          this.$store.dispatch(this.dispatchType, data);
        }
      }
    },
    onAnyClick() {
      let data = this.profile.data;
      let newKey = "";
      for (let i = 0; i < 200; i++) {
        const key = "#009514" + i.toString(16).toUpperCase().padStart(2, "0");
        const anyKey = data.tab_key.find((k) => k.ph_key_data === key);
        if (!anyKey || !anyKey.first_key) {
          newKey = key;
          break;
        }
      }
      if (newKey) {
        if (this.anyKeys.includes(this.selectedKey)) {
          const anyKey = data.tab_key.find(
            (k) => k.ph_key_data === this.selectedKey
          );
          this.anyKey = {
            first_key: null,
            second_key: null,
            interval_time: 200,
            ...anyKey,
            ph_key_data: newKey,
            layer_num: this.layerIndex, //当前键层
            row_num: Math.floor(this.selectedKeyIndex / 25), //行
            index: this.selectedKeyIndex % 25, //列
            old_key: this.selectedKey, //新键值
            new_key: newKey, //新键值
          };
        } else {
          this.anyKey = {
            ph_key_data: newKey,
            first_key: null,
            second_key: null,
            interval_time: 200,
            layer_num: this.layerIndex, //当前键层
            row_num: Math.floor(this.selectedKeyIndex / 25), //行
            index: this.selectedKeyIndex % 25, //列
            old_key: this.selectedKey, //新键值
            new_key: newKey, //新键值
          };
        }
        this.anyVisible = true;
      } else {
        this.$message.info(this.$t("keyboard.any.max"));
      }
    },
    onIntervalInput(e) {
      let time = e.target.value;
      if (time < 200) time = 200;
      if (time > 10000) time = 10000;
      this.anyKey.interval_time = Math.floor(time);
    },
    onAnyOk() {
      let data = this.profile.data;
      if (this.anyKeys.includes(this.selectedKey)) {
        const index = data.tab_key.findIndex(
          (k) => k.ph_key_data === this.selectedKey
        );
        if (index > -1) {
          data.tab_key[index] = this.anyKey;
          this.$store.dispatch(this.dispatchType, data);
        }
      } else {
        data.tab_key.push(this.anyKey);
        this.$store.dispatch(this.dispatchType, data);
      }
      this.onKeyClick(this.anyKey.ph_key_data);
      this.anyVisible = false;
    },
    onMacroClick() {
      let data = this.profile.data;
      let newKey = "";
      for (let i = 0; i < 32; i++) {
        const key = "#009515" + i.toString(16).toUpperCase().padStart(2, "0");
        const macroKey = data.macro_key.find((k) => k.macro_value === key);
        if (!macroKey || !macroKey.original_key) {
          newKey = key;
          break;
        }
      }
      if (newKey) {
        if (this.macroKeys.includes(this.selectedKey)) {
          const macroKey = data.tab_key.find(
            (k) => k.macro_value === this.selectedKey
          );
          this.macroKey = {
            first_key: null,
            second_key: null,
            interval_time: 200,
            ...macroKey,
            macro_value: newKey,
          };
        } else {
          this.macroKey = {
            first_key: null,
            second_key: null,
            interval_time: 200,
            macro_value: newKey,
          };
        }
        this.macroVisible = true;
      } else {
        this.$message.info(this.$t("keyboard.macro.max"));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$key-width: 52px;
$key-margin: 6px;

.c-special-keys {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 (20px - $key-margin) 0 0;

  .title {
    width: 100%;
    font-size: 12px;
    color: $primary-color;
    text-align: left;
    margin: 20px 0 10px 0;
    white-space: nowrap;
  }

  .key {
    @include flex-center;
    width: $key-width;
    height: $key-width;
    margin: 0 $key-margin $key-margin 0;
    border: 1px solid #ffffff;
    cursor: pointer;

    .text {
      font-size: 24px;
      color: #ffffff;
      transform: scale(0.5);
      line-height: 1.1;
    }

    &.selected {
      border-color: $active-color;
      background: $active-color;
    }

    &:hover {
      border-color: $primary-color;
      background: $primary-color;
    }
  }

  .desc {
    width: ($key-width + $key-margin) * 6.3;
    line-height: $key-width / 2;
    font-size: 16px;
    text-align: left;
  }
}
</style>
<style lang="scss">
.any-key-modal,
.macro-key-modal {
  .ant-modal-content {
    border: 1px solid $primary-color;

    .ant-modal-body {
      padding: 80px 90px;

      .any-key,
      .macro-key {
        .title {
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0.1em;
          color: #ffffff;
          margin-bottom: 50px;
        }

        .fields {
          @include flex-center;
          margin-bottom: 10px;

          .field {
            width: 150px;

            + .field {
              margin-left: 20px;
            }

            .md-input {
              width: 110px;
            }
          }
        }

        .buttons {
          @include flex-center;

          .button {
            @include button;
            border: 1px solid $primary-color;
            border-radius: 5px;
            background: transparent;
            color: $primary-color;

            + .button {
              margin-left: 70px;
              background: $primary-color;
              color: #ffffff;
            }

            &:hover {
              color: #ffffff;
            }
          }
        }
      }
    }
  }
}
</style>
